import infoaddReducers from './reducers';
export { default as infoaddOperations } from './operations';
export { default as infoaddTypes } from './types';
export default infoaddReducers;
